module.exports = __webpack_public_path__ + "media/assets/img/flags/bg-BG-11cc6270a3516e9016f237348536116e.png";